import { AccessReviewSubordinateModel } from "models/AccessReviewSubordinateModel";
import { apiReq } from "utils/api/apiReq";

export const getAccessReviewSubordinate = async (id: string): Promise<AccessReviewSubordinateModel> => {
  const { data: accessReviewSubordinate } = await apiReq("GET", `/v1/accessReviewSubordinates/${id}`);

  return AccessReviewSubordinateModel.fromServerData(accessReviewSubordinate);
};
